/**
 * Scroll Effects Module
 *
 * Handles scroll-dependent behaviors:
 * - Header shadow on scroll
 * - Scroll-to-top button
 * - Intersection Observer animations
 */

/**
 * Initialize scroll-related effects.
 */
export function initScrollEffects() {
    console.log('scroll.js loaded', window.location.href);
    initHeaderScroll();
    initScrollAnimations();
    initScrollToTop();
}

/**
 * Add shadow to header on scroll.
 */
function initHeaderScroll() {
    const header = document.querySelector('.hf-header');

    if (!header) {
        return;
    }

    const observer = new IntersectionObserver(
        ([entry]) => {
            header.classList.toggle('is-scrolled', !entry.isIntersecting);
        },
        { threshold: 1, rootMargin: '50px 0px 0px 0px' }
    );

    // Observe a sentinel element at the top
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;width:1px;height:1px;pointer-events:none;';
    document.body.prepend(sentinel);
    observer.observe(sentinel);
}

/**
 * Animate elements on scroll using Intersection Observer.
 *
 * Add `data-animate="fade-up"` to any element to animate it.
 * Supported: fade-up, fade-in, slide-left, slide-right
 */
function initScrollAnimations() {
    const elements = document.querySelectorAll('[data-animate]');

    if (!elements.length) {
        return;
    }

    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        elements.forEach((el) => el.classList.add('is-animated'));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-animated');
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px',
        }
    );

    elements.forEach((el) => observer.observe(el));
}

/**
 * Scroll-to-top button.
 */
function initScrollToTop() {
    const button = document.querySelector('.hf-scroll-top');

    if (!button) {
        return;
    }

    const toggleVisibility = () => {
        button.classList.toggle('is-visible', window.scrollY > 500);
    };

    // Throttle scroll event
    let ticking = false;
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                toggleVisibility();
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}
